import { types } from "../types/types";

const initialState = {
  seleccionado: false,
  afiliado: {},
  seleccionadoConsulta: false,
  consultaAfiliado: {},
  documentacionCompleta: false,
  datosCompletos: false,
};
export const afiliacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.afiliacionesAfiliadoSeleccionado:
      if (action.payload.idConsulta === "idConsulta") {
        return {
          ...state,
          seleccionadoConsulta: true,
          consultaAfiliado: action.payload.afiliado,
        };
      } else {
        return {
          ...state,
          seleccionado: true,
          afiliado: action.payload.afiliado,
        };
      }
    case types.afiliacionesAfiliadoReloadPlanConvenio:
      return {
        ...state,
        afiliado: {
          ...state.afiliado,
          id_plan: action.payload.id_plan,
          id_convenio_prestacional: action.payload.id_convenio_prestacional,
        },
      };
    case types.afiliacionesAfiliadoLimpiarSeleccion:
      return {
        afiliado: {},
        seleccionado: false,
        consultaAfiliado: {},
        documentacionCompleta: false,
        datosCompletos: false,
      };
    case types.afiliacionesAfiliadoConsultaLimpiarSeleccion:
      return {
        afiliado: {},
        consultaAfiliado: {},
        seleccionadoConsulta: false,
      };
    case types.afiliacionesActualizarDocumentacion:
      return {
        ...state,
        documentacionCompleta: action.payload,
      };
    case types.afiliacionesActualizarSeguimiento:
      return {
        ...state,
        seguimiento: action.payload,
      };
    case types.afiliacionesActualizarReclamoSSSalud:
      return {
        ...state,
        reclamoSSSalud: action.payload,
      };
    case types.afiliacionesActualizarSinFicha:
      return {
        ...state,
        afiliado: action.payload
      };
    case types.afiliacionesActualizarDatosPersonales:
      return {
        ...state,
        datosCompletos: action.payload,
      };
    case types.afiliacionesAfiliadoUpdated:
      return {
        ...state,
        afiliado: action.payload,
      };
    default:
      return state;
  }
};
